var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box news-box" }, [
      _c(
        "div",
        { staticClass: "sub-nav" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/noticeIndex" } } },
                [_vm._v("公告栏")]
              ),
              _vm._v(" "),
              _c("el-breadcrumb-item")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "detail-wrapper", attrs: { id: "printTest" } }, [
        _c("div", { staticClass: "detail-title" }, [
          _vm._v(_vm._s(_vm.form.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail-title-sub" }, [
          _vm.form.publishUser
            ? _c("span", [_vm._v("发布单位：" + _vm._s(_vm.form.publishUser))])
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v("时间：" + _vm._s(_vm.form.publishTime))])
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "detail-content",
          domProps: { innerHTML: _vm._s(_vm.safeContent) }
        })
      ]),
      _vm._v(" "),
      _vm.form.enclosure && _vm.form.enclosureName
        ? _c(
            "div",
            { staticStyle: { padding: "0 77px" } },
            [
              _vm._v("\n      附件："),
              _vm._l(_vm.form.enclosure.split(","), function(item, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticStyle: {
                      color: "rgba(1,173,214,1)",
                      "text-decoration": "underline"
                    },
                    attrs: { download: "img", href: _vm.publicPath + item }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        index == _vm.form.enclosureName.split(",").length - 1
                          ? _vm.form.enclosureName.split(",")[index]
                          : _vm.form.enclosureName.split(",")[index] + "，"
                      ) + " "
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "opts" }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "print",
                rawName: "v-print",
                value: _vm.printObj,
                expression: "printObj"
              }
            ],
            staticClass: "b-print",
            attrs: { href: "javascript:void(0);" }
          },
          [_vm._v("打印本文章")]
        ),
        _vm._v(" "),
        _c("a", { staticClass: "b-share b-share-weixin -mob-share-weixin" }),
        _vm._v(" "),
        _c("a", {
          staticClass: "b-share b-share-webo -mob-share-weibo",
          attrs: { target: "_blank" }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e74d884", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e74d884","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notice/detail.vue
// module id = null
// module chunks = 